import { render, staticRenderFns } from "./airline-erstellen.vue?vue&type=template&id=5fb2e3a7&scoped=true"
import script from "./airline-erstellen.vue?vue&type=script&lang=js"
export * from "./airline-erstellen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb2e3a7",
  null
  
)

export default component.exports